import { FoodBeverageContactType } from '@api';
import { DotNotationPaths } from '@common';
import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueFoodBeverageContactTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_FOOD_BEVERAGE_CONTACT.ROWS'>;
  accessor: DotNotationPaths<FoodBeverageContactType>;
};

export const venueFoodBeverageContactRows: VenueFoodBeverageContactTableRowType[] = [
  {
    label: 'CONTACT',
    accessor: 'contact',
  },
  {
    label: 'NOTES',
    accessor: 'notes',
  },
];

